import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=f83f94d0&scoped=true&"
import script from "./CopyButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=f83f94d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83f94d0",
  null
  
)

export default component.exports